import { FC, Fragment, useEffect } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import useMenu from 'hooks/useMenu';
import useToggle from 'hooks/useToggle';
// Redux
import { useAppDispatch } from 'hooks/useStore';
import { getMedia } from 'store/media/mediaAsync';
import MediaFormats from 'types/MediaFormats';
// Components
import { Toolbar } from 'components/Toolbar';
import { Button } from 'components/Buttons';
import MediaList from './MediaList';
import UploadImageDialog from 'dialogs/UploadImage.dialog';
import UploadVideoDialog from 'dialogs/UploadVideo.dialog';

const MediaPage:FC = () => {
  const { t } = useTranslation('common');

  const dispatch = useAppDispatch();

  const { Menu, MenuItem, openMenu } = useMenu();
  const { open:openImageDialog, toggle:toggleImageDialog } = useToggle();
  const { open:openVideoDialog, toggle:toggleVideoDialog } = useToggle();

  useEffect(() => {
    dispatch(getMedia({ scope: ['account'] }));
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      {openImageDialog ? (
        <UploadImageDialog open={openImageDialog} onClose={toggleImageDialog} initialFormat={MediaFormats.Logo} />
      ) : null}
      {openVideoDialog ? (
        <UploadVideoDialog open={openVideoDialog} onClose={toggleVideoDialog} />
      ) : null}

      <div className="container max-w-screen-desktop flex-grow py-4 overflow-y-auto">
        <Toolbar title={t('common.mediaGallery')}>
          <div
            className="
              flex items-center
              order-2 lg:order-none
              w-full lg:w-auto
              mt-4 lg:mt-0
            "
          >
          </div>
          <Button
            variant="contained"
            type="button"
            onClick={openMenu}
          >{t('ownerPage.mediaPage.uploadMedia')}</Button>
          <Menu>
            <MenuItem onClick={toggleImageDialog}>{t('common.image')}</MenuItem>
            <MenuItem onClick={toggleVideoDialog}>{t('common.video')}</MenuItem>
          </Menu>
        </Toolbar>
        <MediaList />
      </div>
    </Fragment>
  )
}

export default MediaPage;
